import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardComponent from './DashboardComponent';
import AlarmSettings from './AlarmSettings';
import Login from './Login';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(process.env.REACT_APP_API_URL + '/check-auth', {
          credentials: 'include'
        });
        const data = await res.json();
        if (data.authenticated) {
          localStorage.setItem('isAuthenticated', 'true');
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem('isAuthenticated');
          localStorage.removeItem('user');
          setIsAuthenticated(false);
        }
      } catch {
        // Dacă serverul nu răspunde, ne bazăm pe localStorage
        const authStatus = localStorage.getItem('isAuthenticated');
        setIsAuthenticated(authStatus === 'true');
      } finally {
        setIsInitialized(true);
      }
    };
    checkSession();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await fetch(process.env.REACT_APP_API_URL + '/logout', {
        method: 'POST',
        credentials: 'include'
      });
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      setIsAuthenticated(false);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  // Nu randa nimic până când aplicația este inițializată
  if (!isInitialized) {
    return <div>Initializing...</div>;
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  // Dacă utilizatorul este autentificat, afișează dashboard-ul
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DashboardComponent onLogout={handleLogout} />} />
        <Route path="/settings" element={<AlarmSettings onLogout={handleLogout} />} />
      </Routes>
    </Router>
  );
}

export default App;
